import React from 'react';
import menaHsEntries2025 from './menaHsEntries2025';
import './MenaGallery.css';

const MenaHsGallery2025 = () => {
    return (
        <div className="mena-gallery-container">
            <h1 className="mena-gallery-title">Mena High School NYX NoCode Hackathon Gallery 2025</h1>
            <p style={{ marginBottom: '2rem', fontSize: '1.1rem', color: '#333' }}>
                The students of Mena High School participated in the NYX NoCode Hackathon in November 2024.
                Students created web content to promote Mena Public Schools clubs, sports, and activities.
            </p>
            <div className="mena-gallery-grid">
                {menaHsEntries2025.map((entry, index) => {
                    const safeTeam = entry.team.replace(/[^\w-]/g, '_');
                    const thumbFile = `${safeTeam}_hs_${index.toString().padStart(3, '0')}.png`;
                    const thumbPath = `/thumbnails/${thumbFile}`;

                    return (
                        <div className="mena-gallery-card" key={`${entry.team}_${index}`}>
                            <a href={entry.url} target="_blank" rel="noopener noreferrer">
                                <img src={thumbPath} alt={`Screenshot for ${entry.team}`} className="mena-gallery-thumb" />
                            </a>
                            <div className="mena-gallery-label">{entry.team}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MenaHsGallery2025;
